<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
export default {
  data() {
    return {
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      showFilterInputs: false,
      RejectSel: ["Status", "Approved", "Rejected"],
      Aksel: ["Approved By", "Jeffrey Akridge"],
    };
  },
  methods: {
    toggleFilterInputs() {
      this.showFilterInputs = !this.showFilterInputs;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div
          class="d-flex justify-content-between align-items-center flex-wrap row-gap-3 mb-4"
        >
          <h5>Holiday & Leave</h5>
          <div class="d-flex align-items-center flex-wrap row-gap-3">
            <span class="fs-14 me-2">Sort</span>
            <div class="dropdown me-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Newly Added
              </a>
              <div class="dropdown-menu">
                <a href="javascript:void(0);" class="dropdown-item active">Ascending</a>
                <a href="javascript:void(0);" class="dropdown-item">Descending</a>
              </div>
            </div>
            <div class="dropdown me-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Export
              </a>
              <div class="dropdown-menu">
                <a href="javascript:void(0);" class="dropdown-item active"
                  >Export as PDF</a
                >
                <a href="javascript:void(0);" class="dropdown-item">Export as Excel</a>
              </div>
            </div>
            <a
              href="javascript:void(0);"
              class="tags d-flex justify-content-center align-items-center border rounded me-2"
              ><i class="ti ti-printer"></i
            ></a>
            <a
              href="javascript:void(0);"
              class="tags d-flex justify-content-center align-items-center border rounded me-2"
              id="filter_search"
              @click="toggleFilterInputs"
              ><i class="ti ti-sort-descending"></i
            ></a>
            <a href="javascript:void(0);" class="btn btn-dark active me-2"
              ><i class="feather-file-text"></i> Leave History</a
            >
            <a
              href="javascript:void(0);"
              class="btn act-btn me-2"
              data-bs-toggle="modal"
              data-bs-target="#add-holiday"
              ><i class="feather-plus"></i> Add Holiday</a
            >
            <a
              href="javascript:void(0);"
              class="btn act-btn add-set"
              data-bs-toggle="modal"
              data-bs-target="#add-leave"
              ><i class="feather-plus"></i> Add Leave</a
            >
          </div>
        </div>
        <div
          id="filter_inputs"
          v-bind:style="{ display: showFilterInputs ? 'block' : 'none' }"
        >
          <div class="row">
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <div class="sel-cal Calendar-icon">
                  <span><i class="ti ti-calendar-month"></i></span>
                  <date-picker
                    v-model="startdate"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="Aksel" id="aksel" placeholder="Approved By" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="RejectSel" id="rejectsel" placeholder="Status" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="provide-table manage-table">
            <div class="table-responsive">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th>Leave Date</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Approved By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <h6 class="fs-14 fw-normal">May 03, 2024 - May 04, 2024</h6>
                      <span class="fs-12">2days</span>
                    </td>
                    <td>Out for personal reasons.</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center">
                          <i class="ti ti-point-filled"></i>
                          Approved
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <a href="javascript:void(0);">
                          <span class="avatar avatar-lg me-2">
                            <img
                              src="@/assets/img/profiles/avatar-02.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                        </a>
                        <div>
                          <h6 class="fs-14 fw-normal">
                            <a href="javascript:void(0);">Jeffrey Akridge,</a>
                          </h6>
                          <span class="fs-12">Admin</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-leave"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-leave"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 class="fs-14 fw-normal">Jun 10, 2024 - Jun 12, 2024</h6>
                      <span class="fs-12">3 days</span>
                    </td>
                    <td>Health Issues.</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center">
                          <i class="ti ti-point-filled"></i>
                          Approved
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <a href="javascript:void(0);">
                          <span class="avatar avatar-lg me-2">
                            <img
                              src="@/assets/img/profiles/avatar-02.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                        </a>
                        <div>
                          <h6 class="fs-14 fw-normal">
                            <a href="javascript:void(0);">Jeffrey Akridge,</a>
                          </h6>
                          <span class="fs-12">Admin</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-leave"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-leave"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 class="fs-14 fw-normal">Jun 18, 2024 - Jun 18, 2024</h6>
                      <span class="fs-12">1 days</span>
                    </td>
                    <td>Out for medical appointments.</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center">
                          <i class="ti ti-point-filled"></i>
                          Approved
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <a href="javascript:void(0);">
                          <span class="avatar avatar-lg me-2">
                            <img
                              src="@/assets/img/profiles/avatar-02.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                        </a>
                        <div>
                          <h6 class="fs-14 fw-normal">
                            <a href="javascript:void(0);">Jeffrey Akridge,</a>
                          </h6>
                          <span class="fs-12">Admin</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-leave"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-leave"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 class="fs-14 fw-normal">Jul 08, 2024 - Jul 10, 2024</h6>
                      <span class="fs-12">3 days</span>
                    </td>
                    <td>Away due to a family event.</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center">
                          <i class="ti ti-point-filled"></i>
                          Approved
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <a href="javascript:void(0);">
                          <span class="avatar avatar-lg me-2">
                            <img
                              src="@/assets/img/profiles/avatar-02.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                        </a>
                        <div>
                          <h6 class="fs-14 fw-normal">
                            <a href="javascript:void(0);">Jeffrey Akridge,</a>
                          </h6>
                          <span class="fs-12">Admin</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-leave"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-leave"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 class="fs-14 fw-normal">Jul 20, 2024 - Jul 20, 2024</h6>
                      <span class="fs-12">1 days</span>
                    </td>
                    <td>Absent due to weather conditions.</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center">
                          <i class="ti ti-point-filled"></i>
                          Approved
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <a href="javascript:void(0);">
                          <span class="avatar avatar-lg me-2">
                            <img
                              src="@/assets/img/profiles/avatar-02.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                        </a>
                        <div>
                          <h6 class="fs-14 fw-normal">
                            <a href="javascript:void(0);">Jeffrey Akridge,</a>
                          </h6>
                          <span class="fs-12">Admin</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-leave"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-leave"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 class="fs-14 fw-normal">Aug 13, 2024 - Aug 14, 2024</h6>
                      <span class="fs-12">2 days</span>
                    </td>
                    <td>Personal Illness.</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center">
                          <i class="ti ti-point-filled"></i>
                          Approved
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <a href="javascript:void(0);">
                          <span class="avatar avatar-lg me-2">
                            <img
                              src="@/assets/img/profiles/avatar-02.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                        </a>
                        <div>
                          <h6 class="fs-14 fw-normal">
                            <a href="javascript:void(0);">Jeffrey Akridge,</a>
                          </h6>
                          <span class="fs-12">Admin</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-leave"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-leave"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 class="fs-14 fw-normal">Aug 22, 2024 - Aug 24, 2024</h6>
                      <span class="fs-12">3 days</span>
                    </td>
                    <td>Out for vacation.</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center">
                          <i class="ti ti-point-filled"></i>
                          Approved
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <a href="javascript:void(0);">
                          <span class="avatar avatar-lg me-2">
                            <img
                              src="@/assets/img/profiles/avatar-02.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                        </a>
                        <div>
                          <h6 class="fs-14 fw-normal">
                            <a href="javascript:void(0);">Jeffrey Akridge,</a>
                          </h6>
                          <span class="fs-12">Admin</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-leave"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-leave"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="table-paginate d-flex justify-content-between align-items-center flex-wrap row-gap-3"
          >
            <div class="value d-flex align-items-center">
              <span>Show</span>
              <select>
                <option>7</option>
              </select>
              <span>entries</span>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <span class="me-2 text-gray-9">1 - 07 of 10</span>
              <nav aria-label="Page navigation">
                <ul class="paginations d-flex justify-content-center align-items-center">
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 active d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >1</a
                    >
                  </li>
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >2</a
                    >
                  </li>
                  <li class="page-item">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >3</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
